<template>
  <div class="rel">
    <div
      class="myCheckBox abs"
      style="    top: 47px;
    z-index: 5;
    left: 6px;"
    >
      <input
        type="checkbox"
        class="filled-in"
        v-model="selectAll"
        id="chckMassConfirmableElektraWeb"
      /><label for="chckMassConfirmableElektraWeb"></label>
    </div>
    <dataTable
      :name="'kolayrezTempReservationElektraWeb'"
      ref="agGrid"
      :columnDefs="columnDefs"
      :data="data"
      :rowClassRules="{
        // row style function
        danger: (params) => {
          // var numSickDays = params.data;
          return params?.data?.HasError;
        },
      }"
      :addContextMenuItem="getContextMenuItems"
      @cellClicked="onCellClicked"
    ></dataTable>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "elektraWeb",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectAll: false,
      columnDefs: [
        {
          headerName: "",
          width: 55,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
          enableRowGroup: false,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 70,
        },
        {
          headerName: "Customer",
          field: "CustomerName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Hotel",
          field: "HotelName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Res Id",
          field: "ResId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Guest Id",
          field: "ResGuestId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Last CheckIn",
          field: "LastCheckIn",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "Last Reservation Id",
          field: "LastReservationId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Last Using Date",
          field: "LastUsingDate",
          enableRowGroup: true,
          filter: false,
          flex: 1,
          minWidth: 140,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "Last Using User",
          field: "LastUsingUser",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Reseted",
          field: "Reseted",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 100,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Is Using",
          field: "IsUsing",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 90,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Active",
          field: "Active",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 90,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
    };
  },
  watch: {
    selectAll() {
      if (!this.selectAll) {
        this.data.forEach((element) => {
          if (element.isSelected) {
            element.isSelected = false;
            this.$refs.agGrid.changeRow("Id", element);
          }
        });
        this.emitSelectionChange();
        return false;
      }
      if (!this.$refs.agGrid?.gridApi) {
        return;
      }
      const currentPage = this.$refs.agGrid.gridApi.paginationGetCurrentPage();
      const pageSize = this.$refs.agGrid.gridApi.paginationGetPageSize();
      let pager = {
        min: currentPage * pageSize,
        max: (currentPage + 1) * pageSize,
      };
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort(
        (rowNode, index) => {
          if (index >= pager.min && index < pager.max) {
            this.$refs.agGrid.changeRow("Id", {
              ...rowNode.data,
              isSelected: true,
            });
          }
        }
      );
      this.emitSelectionChange();
    },
  },
  methods: {
    emitSelectionChange() {
      this.$emit(
        "selectionChanged",
        this.data.filter((x) => x.isSelected).length
      );
    },
    onCellClicked(param) {
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("Id", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.emitSelectionChange();
      }
    },
    resetSelection() {
      this.data.forEach((element) => {
        if (element.isSelected) {
          element.isSelected = false;
          this.$refs.agGrid.changeRow("Id", element);
        }
      });
      this.selectAll = false;
      this.emitSelectionChange();
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        params.node.data.Active?{
          name: "Reset Temp Reservation",
          icon: "<i class='mdi mdi-sync'></i>",
          action: () => {
            this.resetTempReservation(params.node.data);
          },
        }:undefined,
        {
          name: params.node.data.Active ? "Passive" : "Active",
          icon:
            "<i class='fas " +
            (params.node.data.Active ? "fa-square" : "fa-check-square") +
            "'></i>",
          action: () => {
            this.$appAxiosAdmin
              .get(
                "TempReservations/" +
                  params.node.data.Id +
                  "/UpdateActive?active=" +
                  !params.node.data.Active
              )
              .then(() => {
                this.$refs.agGrid.changeRow("Id", {
                  ...params.node.data,
                  Active: !params.node.data.Active,
                });
              })
              .catch((err) => {
                this.$isError(err);
              });
          },
        },
      ];
      return result;
    },
    resetTempReservation(item) {
      this.$appAxiosAdmin
        .get(`Hotels/` + item.HotelId + "/TempReservations/"+item.Id+"/Reset")
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Temporary reservation reset successfully.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
